<div
  class="landing-promo-banner-wrapper"
  (click)="toggle()"
  (keydown.enter)="toggle()"
  role="button"
  tabindex="0"
  aria-label="Toggle"
>
  <ng-container *ngIf="isOpen; else closedBanner">
    <svg
      class="landing-promo-banner-svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 65 65"
    >
      <defs />
      <defs><rect id="a" width="65" height="65" x="0" y="0" rx="6" /></defs>
      <g fill="none" fill-rule="evenodd">
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <use class="landing-promo-banner-present-background" xlink:href="#a" />
        <g fill="#F87A1D" fill-rule="nonzero" mask="url(#b)">
          <path
            d="M36.918 40.904h-15.15c-1.2 0-2.182.982-2.182 2.182v16.381c0 1.2.982 2.183 2.183 2.183h15.404c.513 0 .513-.552.513-.552V41.645s0-.741-.768-.741zm20.372 0H42.156c-.922 0-.784.96-.784.96v19.252s-.007.533.547.533H57.29c1.2 0 2.183-.982 2.183-2.182v-16.38c0-1.201-.982-2.183-2.183-2.183zM24.258 24.092s-.455-.582-1.03-.132L9.317 34.827a2.189 2.189 0 00-.377 3.063l4.195 5.369a2.189 2.189 0 003.063.376l13.957-10.904c.529-.413.17-.872.17-.872l-6.068-7.767zm16.935-14.17L27.24 20.826c-.532.415-.136.921-.136.921L33.24 29.6s.35.448.996-.057l13.84-10.812a2.189 2.189 0 00.375-3.064L44.257 10.3a2.189 2.189 0 00-3.064-.376zM16.959 26.808a14.264 14.264 0 01-2.28 1.483c-1.846.938-3.422 1.189-4.818.767-1.252-.378-2.244-1.274-2.95-2.663-1.236-2.43-.727-4.697 1.432-6.384.457-.357 1-.696 1.614-1.008 1.562-.794 3.902-1.371 6.26-1.544 4.002-.293 4.987.7 5.38 1.471.576 1.135.205 2.556-1.133 4.347-.905 1.21-2.182 2.497-3.505 3.53zm-6.463-4.04c-.836.653-.94 1.111-.467 2.042.387.761.73.865.843.899.47.142 1.26-.048 2.22-.537.52-.263 1.112-.651 1.713-1.121 1.322-1.033 2.33-2.144 2.932-2.967.044-.06.08-.194-.058-.177-1.653-.034-4.36.311-6.137 1.214-.414.21-.766.428-1.046.647zM31.603 15.367c-1.324 1.034-2.881 1.962-4.274 2.547-2.061.865-3.53.88-4.492.047-.653-.568-1.378-1.763-.126-5.575.738-2.246 1.865-4.378 3.013-5.702.452-.52.912-.965 1.369-1.321 2.159-1.687 4.482-1.632 6.54.155 1.177 1.02 1.807 2.2 1.87 3.506.072 1.457-.553 2.925-1.91 4.489a14.285 14.285 0 01-1.99 1.854zm-5.891-.763c-.05.122.058.17.115.147.946-.381 2.284-1.096 3.622-2.14.601-.47 1.12-.951 1.502-1.391.707-.814 1.083-1.534 1.058-2.025-.005-.118-.023-.476-.668-1.035-.789-.685-1.259-.694-2.095-.04-.28.218-.575.506-.88.857-1.306 1.505-2.287 4.014-2.654 5.627z"
          />
        </g>
      </g>
    </svg>
  </ng-container>
  <ng-template #closedBanner>
    <svg
      class="landing-promo-banner-svg"
      xmlns="http://www.w3.org/2000/svg"
      xmlns:xlink="http://www.w3.org/1999/xlink"
      viewBox="0 0 65 65"
    >
      <defs />
      <defs><rect id="a" width="65" height="65" x="0" y="0" rx="6" /></defs>
      <g fill="none" fill-rule="evenodd">
        <mask id="b" fill="#fff"><use xlink:href="#a" /></mask>
        <use class="landing-promo-banner-present-background" xlink:href="#a" />
        <g fill="#F87A1D" fill-rule="nonzero" mask="url(#b)">
          <path
            d="M30.074 34.029h-15.15c-1.2 0-2.182.982-2.182 2.182v16.381c0 1.2.982 2.183 2.183 2.183h15.404c.513 0 .513-.552.513-.552V34.77s0-.741-.768-.741zm20.372 0H35.312c-.922 0-.784.96-.784.96V54.24s-.007.533.547.533h15.371c1.2 0 2.183-.982 2.183-2.182v-16.38c0-1.201-.982-2.183-2.183-2.183zM30.842 21.14s0-.74-.73-.74H12.46c-1.2 0-2.182.982-2.182 2.182v6.813c0 1.2.982 2.183 2.182 2.183h17.711c.671 0 .671-.582.671-.582V21.14zm22.07-.74H35.202c-.674 0-.674.643-.674.643v9.966s0 .569.82.569H52.91c1.2 0 2.183-.982 2.183-2.183v-6.813c0-1.2-.983-2.182-2.183-2.182zM23.42 18.785c-1 0-1.912-.08-2.711-.235-2.032-.397-3.428-1.17-4.27-2.362-.752-1.068-.983-2.385-.685-3.914.523-2.676 2.32-4.149 5.06-4.149.58 0 1.216.067 1.892.2 1.72.335 3.92 1.321 5.885 2.637 3.333 2.233 3.498 3.62 3.332 4.47-.244 1.25-1.411 2.142-3.569 2.729-1.457.397-3.256.624-4.935.624zm-2.606-7.162c-1.061 0-1.426.296-1.626 1.322-.164.838.043 1.13.11 1.227.284.402 1.023.738 2.081.944.571.112 1.277.17 2.04.17 1.678 0 3.156-.254 4.137-.532.072-.02.182-.104.064-.175-1.283-1.045-3.629-2.44-5.585-2.822a6.506 6.506 0 00-1.221-.134zm21.189 7.162c-1.68 0-3.478-.227-4.936-.624-2.157-.587-3.324-1.48-3.568-2.728-.166-.85-.002-2.238 3.332-4.47 1.965-1.317 4.165-2.303 5.885-2.639a9.952 9.952 0 011.892-.199c2.74 0 4.537 1.474 5.059 4.15.299 1.528.068 2.845-.685 3.913-.841 1.193-2.237 1.965-4.27 2.362-.799.156-1.71.235-2.71.235zm-4.173-4.228c-.114.066-.059.17 0 .187.98.282 2.475.543 4.172.543.764 0 1.47-.06 2.04-.17 1.058-.207 1.798-.543 2.081-.945.068-.096.275-.39.11-1.227-.2-1.025-.564-1.322-1.625-1.322-.355 0-.766.045-1.222.134-1.956.382-4.274 1.755-5.556 2.8z"
          />
        </g>
      </g>
    </svg>
  </ng-template>
</div>

<div *ngIf="isOpen" class="landing-promo-banner-details">
  <div class="landing-promo-banner-details-header">
    <span class="landing-promo-banner-details-header-title">{{ title }}</span>
    <button mat-icon-button class="landing-promo-banner-details-header-button" (click)="toggle()" aria-label="Close">
      <mat-icon fontSet="material-icons-round"> close </mat-icon>
    </button>
  </div>
  <figure
    class="landing-promo-banner-details-figure"
    (click)="onClickDetails()"
    (keydown.enter)="onClickDetails()"
    [class.landing-promo-banner-details-figure-clickable]="isClickable"
    role="link"
    tabindex="0"
  >
    <img [src]="imageSrc" [alt]="title" />
  </figure>
</div>
